import React from "react";
import Login from "@/pages/Login";
import SignUp from '@/pages/SignUp';
import PersonalCenter from "@/pages/PersonalCenter";
import RetrievePassword from '@/pages/RetrievePassword';
import SetPassword from '@/pages/SetPassword';
import OpenVip from '@/pages/PersonalCenter/children/OpenVip';
import OrderList from '@/pages/PersonalCenter/children/OrderList';
import EnterpriseInvoice from "@/pages/PersonalCenter/children/EnterpriseInvoice";
import PersonInfo from '@/pages/PersonalCenter/children/PersonInfo'
import ProductList from "@/pages/PersonalCenter/children/ProductList";
import EditPassword from '@/pages/EditPassword';
import SuccessPage from "@/pages/SuccessPage";
import NotFoundPage from '@/pages/NotFoundPage'
import TransferPage from "@/pages/TransferPage";
import { Navigate } from "react-router-dom";

const routes =  [
	// {
	// 	path:'/login',
	// 	element:<Login />,
	// },
	// {
	// 	path:'/register',
	// 	element:<SignUp />
	// },
    {
		path:'/forgot-password',
		element:<RetrievePassword />
	},
    {
		path:'/set-password',
		element:<SetPassword />
	},
  //   {
	// 	path:'/update-password',
	// 	element:<EditPassword />
	// },
    {
		path:'/set-success',
		element:<SuccessPage />
	},
	{
		path:'/personal-center',
		element: <Navigate to="/personal-center/product-list"/>,
	},
	{
		path:'/personal-center',
		element: <PersonalCenter />,
		children:[
			{
				path: 'order-list',
				element: <OrderList />,
				meta:{
					title: '订单信息-个人中心',
					keywords: '牛学长产品订单信息',
					description: '查询已购买的牛学长产品订单信息'
				},
			},
      {
				path: 'product-info',
				element: <OpenVip />
			},
      {
				path: 'enterprise-invoice',
				element: <EnterpriseInvoice />
			},
			{
				path: 'personal-info',
				element: <PersonInfo />
			},
			{
				path: 'product-list',
				element: <ProductList />
			},
		],
	},
	{
		path: '/transfer-page',
		element: <TransferPage />
	},
	// {
	// 	path: '/404',
	// 	element: <NotFoundPage />
	// },
	{
		path:'/',
		element: <Navigate to="/personal-center/product-list"/>,
	},
	// {
	// 	path:'*',
	// 	element: <Navigate to="/404"/>,
	// },
]


export default routes;
